import { render, staticRenderFns } from "./carpetas.vue?vue&type=template&id=7eb16c27&scoped=true&"
import script from "./carpetas.vue?vue&type=script&lang=js&"
export * from "./carpetas.vue?vue&type=script&lang=js&"
import style0 from "./carpetas.vue?vue&type=style&index=0&id=7eb16c27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb16c27",
  null
  
)

export default component.exports